import React from 'react';
import { Box, Container, Typography, Link as MuiLink, Divider } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { DATA_INTELLIGENZ_URL } from '../constants/brand';

const APP_BUILD_ID = process.env.REACT_APP_GIT_SHA || 'dev';

function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        mt: 'auto',
        bgcolor: 'primary.main',
        color: 'common.white',
        borderTop: '2px solid',
        borderTopColor: 'secondary.main',
      }}
    >
      <Container maxWidth="lg" sx={{ py: 2.5 }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: { xs: 'flex-start', sm: 'center' },
            justifyContent: 'space-between',
            gap: 1.5,
          }}
        >
          <Box>
            <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
              Kepler Approval Board
            </Typography>
            <Typography variant="caption" sx={{ color: 'grey.400' }}>
              © {new Date().getFullYear()} Kepler · {APP_BUILD_ID}
              {' · '}
              Desarrollado por{' '}
              <MuiLink
                href={DATA_INTELLIGENZ_URL}
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
                sx={{ color: 'grey.300', fontWeight: 500 }}
              >
                Data Intelligenz
              </MuiLink>
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <MuiLink
              component={RouterLink}
              to="/about"
              underline="hover"
              sx={{ color: 'grey.300', fontSize: 13, fontWeight: 500 }}
            >
              Acerca de
            </MuiLink>
            <MuiLink
              href={DATA_INTELLIGENZ_URL}
              target="_blank"
              rel="noopener noreferrer"
              underline="hover"
              sx={{ color: 'grey.300', fontSize: 13, fontWeight: 500 }}
            >
              Data Intelligenz
            </MuiLink>
            <Divider orientation="vertical" flexItem sx={{ borderColor: 'grey.700' }} />
            <Typography variant="caption" sx={{ color: 'grey.400' }}>
              Plataforma de autorización de órdenes
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}

export default Footer;
